import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';

interface DownloadInvoiceParams {
  invoice_id: number;
}

export const useDownloadInvoice = () => {
  const downloadInvoice = async ({ invoice_id }: DownloadInvoiceParams) => {
    const response = await Axios.get(
      GET_URL(invoice_id.toString()).donwloadInvoice,
      {
        responseType: 'blob'
      }
    );

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', `invoice_${invoice_id}.pdf`);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);

    return response.data;
  };

  return useMutation(downloadInvoice);
};
